import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { FinishExamResponse } from '@/queries'

export const useExamResultStore = defineStore(
  'exam',
  () => {
    const examResult = ref<FinishExamResponse>()
    function setExamResult(result: FinishExamResponse) {
      examResult.value = { ...result }
    }
    function clearExamResult() { examResult.value = undefined }
    return { examResult, setExamResult, clearExamResult }
  },
  {
    persist: true
  }
)
